import React, { useState } from "react";
import Day1Card from "../../day1_card/Day1_Card";
import Day2Card from "../../day2_card/Day2_Card";
import Day3Card from "../../day3_card/Day3_Card";
import { Accordion } from "react-bootstrap";
import "./Flights.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import Inner_Flight_Tab from "./inner_flight_tab/Inner_Flight_Tab";

const Flights = ({ data }) => {
  const [activeTab, setActiveTab] = useState("Itinerary");
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  const staticData = {
    type: "flight",
    title: "Day 03 – Transfer to Akureyri | Day at Leisure",
    description:
      "Today, after check-out, board your transfer to Reykjavik Airport for your flight to Akureyri. Upon arrival at Akureyri Airport, get transferred to your hotel and check-in. Then, spend the rest of your day at leisure. You can explore the serene Akureyri Botanical Garden, home to a diverse collection of Arctic and temperate plants, or stroll through The Old Town, where you can admire the charming wooden houses and soak in the local culture. Afterwards, return to your hotel for an overnight stay.",

    airline: "Icelandair",

    type: "flight",
    airline: "Icelandair",

    from: "RKV",
    fromCity: "Iceland",

    to: "AEY",
    toCity: "Akureyri",

    departTime: "15:30",
    arriveTime: "16:15",

    duration: "45m",

    baggageCabin: "N/A",
    baggageCheckin: "N/A",

    refund: "Non Refundable",

    transferType: "Private Transfer",
    transferMode: "Transfer in Sedan",
  };
  
  const icons = {
    meal: "/assets/images/cruise/itenarary/day-meal.png",
    checkout: "/assets/images/cruise/itenarary/checkout.png",
    car: "/assets/images/cruise/itenarary/private-tranfer.png",
    bed: "/assets/images/cruise/itenarary/bed-img.png",
    map: "/assets/images/cruise/itenarary/activity.png",
    flight: "/assets/images/cruise/itenarary/flight1.png",
  };

  return (
    <div className="Itinerary_Tab">
      <>
        <div className="city_header">
          {data?.title} - <span>{data?.duration}</span>
        </div>

        <Accordion defaultActiveKey="0" className="custom_accordion">
          {data?.itineraries?.map((d, index) => (
            <Accordion.Item eventKey={index.toString()}>
              <Accordion.Header>
                {d?.title}

                <div className="icon_holder">
                  <FontAwesomeIcon
                    icon={faAngleDown}
                    className="inner_icon down_icon"
                  />
                  <FontAwesomeIcon
                    icon={faAngleUp}
                    className="inner_icon up_icon"
                  />
                </div>
              </Accordion.Header>

              <Accordion.Body>
                <Inner_Flight_Tab
                  item={d}
                  staticData={staticData}
                  icons={icons}
                />
              </Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </>
    </div>
  );
};

export default Flights;
